var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-container',{attrs:{"py-0":"","fluid":""}},[_c('v-row',_vm._l((_vm.cats),function(cat){return _c('v-col',{key:cat},[_c('app-filter',{attrs:{"items":_vm.selects[cat],"filter":_vm.filters[cat],"cat":cat,"criteriaFilter":_vm.criteriaFilters[cat]},on:{"filterUpdate":_vm.filterUpdate}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }